import { useMemo } from "react";
import useRolesPermissions from "./useRolesPermissions";
import { CorporationsEntity } from "entities/Corporations/CorporationsEntity";
import { isApiAdministrator } from "utilities/utilities";

export const useAllowCorporateDashboard = () => {
    const { CORPORATE_PERMISSIONS } = useRolesPermissions();
    const { corporations } = CorporationsEntity.GetMenuCorporateDivisionsRegionsMills(isApiAdministrator());

    const isAllowedToUseCorporateDashboard = useMemo(() => {
        if (CORPORATE_PERMISSIONS?.sidebarPermissions?.showCorporateDashboardLink && corporations.length > 0) {
            return corporations[0]?.mills && corporations[0].mills.length > 1;
        }
        return false;
    }, [CORPORATE_PERMISSIONS?.sidebarPermissions?.showCorporateDashboardLink, corporations]);

    const isCorporationsListLoaded = useMemo(() => corporations && corporations.length > 0, [corporations]);

    return { isAllowedToUseCorporateDashboard, isCorporationsListLoaded };
};
